import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["on", "disabled", "onToggle"];
import React from 'react';
import { palette } from '../styles';
import { StyledCheckIcon, StyledSlider, StyledToggle, StyledToggleInput, StyledXIcon } from './Toggle.styled';
export function Toggle(props) {
  var on = props.on,
    disabled = props.disabled,
    onToggle = props.onToggle,
    htmlProps = _objectWithoutProperties(props, _excluded);
  var toggle = function toggle(e) {
    e.stopPropagation();
    if (!disabled) {
      props.onToggle();
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledToggleInput, _extends({
    type: "checkbox",
    role: "switch",
    checked: on,
    "aria-checked": on,
    "aria-readonly": disabled,
    disabled: disabled,
    onChange: toggle
  }, htmlProps)), /*#__PURE__*/React.createElement(StyledToggle, {
    isChecked: on,
    disabled: disabled,
    onClick: toggle,
    role: "presentation"
  }, /*#__PURE__*/React.createElement(StyledCheckIcon, {
    size: 12,
    color: palette.white
  }), /*#__PURE__*/React.createElement(StyledXIcon, {
    size: 12,
    color: palette.white
  }), /*#__PURE__*/React.createElement(StyledSlider, {
    isChecked: on
  })));
}